import type { ReactNode } from 'react';

/**
 * §13 — "temiz tablo/kart düzeni". Tüm bölümler bu kabuğu kullanır:
 * referans paneldeki beyaz yüzey (rounded-2xl + #e5e7eb kenarlık),
 * isteğe bağlı başlık satırı ve sağ eylem alanı.
 */

export interface CardProps {
  title?: ReactNode;
  /** Başlığın altındaki açıklama — metriğin ne anlama geldiği. */
  subtitle?: ReactNode;
  /** Başlık satırının sağ ucu (segment seçici, "tümünü gör" bağlantısı…). */
  actions?: ReactNode;
  /** Gövde iç boşluğunu kaldırır — kenardan kenara tablo yerleşimi için. */
  flush?: boolean;
  /** Kartın alt şeridi (sayfalama, toplam satırı…). */
  footer?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children?: ReactNode;
}

export default function Card({
  title,
  subtitle,
  actions,
  flush = false,
  footer,
  className = '',
  bodyClassName = '',
  children,
}: CardProps) {
  const hasHeader = title !== undefined || subtitle !== undefined || actions !== undefined;
  return (
    <section
      className={`overflow-hidden rounded-2xl border border-[#e5e7eb] bg-white ${className}`}
    >
      {hasHeader ? (
        <header className="flex flex-wrap items-start justify-between gap-3 border-b border-[#e5e7eb] px-5 py-3.5">
          <div className="min-w-0">
            {title !== undefined ? (
              <h2 className="truncate text-[14px] font-semibold text-[#111827]">{title}</h2>
            ) : null}
            {subtitle !== undefined ? (
              <p className="mt-0.5 text-[12px] text-[#9ca3af]">{subtitle}</p>
            ) : null}
          </div>
          {actions !== undefined ? (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          ) : null}
        </header>
      ) : null}

      <div className={`${flush ? 'p-0' : 'p-5'} ${bodyClassName}`}>{children}</div>

      {footer !== undefined ? (
        <footer className="border-t border-[#e5e7eb] bg-[#fafafa] px-5 py-3 text-[13px] text-[#6b7280]">
          {footer}
        </footer>
      ) : null}
    </section>
  );
}
